import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10dd1492"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_3 = {
  key: 0,
  class: "rounded-lg border border-amber-200 bg-amber-50 p-4 text-amber-800"
}
const _hoisted_4 = {
  key: 1,
  class: "rounded-lg border border-blue-200 bg-blue-50 p-4 text-blue-800"
}
const _hoisted_5 = {
  key: 2,
  class: "rounded-lg border border-gray-200 bg-white p-5 space-y-4"
}
const _hoisted_6 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_7 = { class: "text-lg font-semibold" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Message ID", -1))
const _hoisted_12 = { class: "break-all" }
const _hoisted_13 = {
  key: 0,
  class: "rounded bg-gray-50 p-3"
}
const _hoisted_14 = {
  key: 1,
  class: "rounded bg-red-50 p-3 text-red-700"
}
const _hoisted_15 = {
  key: 2,
  class: "flex flex-wrap gap-3"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "text-lg font-semibold" }
const _hoisted_18 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "flex flex-wrap gap-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]

import { computed, onMounted, reactive, ref } from "vue";
import { useToast } from "vue-toastification";
import { t } from "@/i18n";
import EnbekDataService from "@/services/enbek/EnbekDataService";
import {
  EnbekEligibility,
  EnbekRegistration,
  EnbekSaveRequest,
} from "@/types/enbek/Enbek";
import EnbekStatusBadge from "./EnbekStatusBadge.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    documentId: null
  },
  setup(__props: any) {

const props = __props as { documentId: string | number }


const toast = useToast();
const loading = ref(true);
const saving = ref(false);
const submitting = ref(false);
const editing = ref(false);
const eligibility = ref<EnbekEligibility | null>(null);
const registration = ref<EnbekRegistration | null>(null);
const today = new Date().toISOString().slice(0, 10);
const form = reactive<any>({
  contractNumber: "",
  contractDate: today,
  beginDate: today,
  endDate: "",
  contractTermCode: "1",
  establishedPostCode: "",
  establishedPost: "1",
  partTimeCode: "1",
  remoteWorkCode: "",
  workPlace: "",
  workPlaceKato: "",
  workPlaceCountry: "KZ",
  workingHoursCode: "1",
  tariffRate: undefined,
  electronicContractCode: "1",
});
const canEdit = computed(() =>
  ["DRAFT", "REJECTED", "TECHNICAL_ERROR"].includes(
    registration.value?.status || ""
  )
);
const showForm = computed(
  () => eligibility.value?.eligible && (!registration.value || editing.value)
);

const fillForm = () => {
  if (!registration.value) return;
  Object.keys(form).forEach((key) => {
    const value = (registration.value as any)[key];
    if (value !== undefined && value !== null) form[key] = value;
  });
};
const load = async () => {
  loading.value = true;
  try {
    const [eligibilityResult, registrationResult] = await Promise.all([
      EnbekDataService.eligibility(props.documentId),
      EnbekDataService.registration(props.documentId),
    ]);
    eligibility.value = eligibilityResult.data.data;
    registration.value = registrationResult.data.data;
    fillForm();
  } finally {
    loading.value = false;
  }
};
const payload = (): EnbekSaveRequest => ({
  employeeUserId: eligibility.value!.employeeUserId!,
  ...form,
  endDate: form.endDate || null,
  tariffRate: form.tariffRate || null,
});
const save = async (sendAfter: boolean) => {
  saving.value = true;
  try {
    const result = await EnbekDataService.save(props.documentId, payload());
    registration.value = result.data.data;
    editing.value = false;
    toast.success(t("enbek.saved"));
    if (sendAfter) await submitRegistration();
  } catch {
    toast.error(t("enbek.saveError"));
  } finally {
    saving.value = false;
  }
};
const submitRegistration = async () => {
  if (!registration.value) return;
  submitting.value = true;
  try {
    const result = await EnbekDataService.submit(registration.value.id);
    registration.value = result.data.data;
    if (registration.value?.status === "REGISTERED")
      toast.success(t("enbek.registered"));
    else if (
      registration.value?.status === "TECHNICAL_ERROR" ||
      registration.value?.status === "REJECTED"
    )
      toast.error(t("enbek.sendError"));
    else toast.success(t("enbek.sent"));
  } catch {
    toast.error(t("enbek.sendError"));
  } finally {
    submitting.value = false;
  }
};
onMounted(load);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("common.loading")), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (eligibility.value && !eligibility.value.eligible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(eligibility.value.reason), 1))
            : _createCommentVNode("", true),
          (eligibility.value && !eligibility.value.integrationEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)("enbek.transportDisabled")), 1))
            : _createCommentVNode("", true),
          (registration.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(t)("enbek.registration")), 1),
                  _createVNode(EnbekStatusBadge, {
                    status: registration.value.status
                  }, null, 8, ["status"])
                ]),
                _createElementVNode("dl", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createElementVNode("dt", null, _toDisplayString(_unref(t)("enbek.contractNumber")), 1),
                    _createElementVNode("dd", null, _toDisplayString(registration.value.contractNumber), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("dt", null, _toDisplayString(_unref(t)("enbek.employee")), 1),
                    _createElementVNode("dd", null, _toDisplayString(registration.value.employeeName) + " · " + _toDisplayString(registration.value.employeeIin), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("dt", null, _toDisplayString(_unref(t)("enbek.employer")), 1),
                    _createElementVNode("dd", null, _toDisplayString(registration.value.employerName) + " · " + _toDisplayString(registration.value.employerBin), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("dt", null, _toDisplayString(_unref(t)("enbek.position")), 1),
                    _createElementVNode("dd", null, _toDisplayString(registration.value.positionName), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("dt", null, _toDisplayString(_unref(t)("enbek.beginDate")), 1),
                    _createElementVNode("dd", null, _toDisplayString(registration.value.beginDate), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("dt", null, _toDisplayString(_unref(t)("enbek.endDate")), 1),
                    _createElementVNode("dd", null, _toDisplayString(registration.value.endDate || "—"), 1)
                  ]),
                  (registration.value.externalContractId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("dt", null, _toDisplayString(_unref(t)("enbek.externalId")), 1),
                        _createElementVNode("dd", null, _toDisplayString(registration.value.externalContractId), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (registration.value.messageId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("dd", _hoisted_12, _toDisplayString(registration.value.messageId), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (registration.value.businessMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(registration.value.businessMessage), 1))
                  : _createCommentVNode("", true),
                (registration.value.lastError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(registration.value.lastError), 1))
                  : _createCommentVNode("", true),
                (_unref(canEdit))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("button", {
                        class: "px-4 py-2 border rounded-lg",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (editing.value = true))
                      }, _toDisplayString(_unref(t)("common.edit")), 1),
                      _createElementVNode("button", {
                        class: "px-4 py-2 rounded-lg bg-primary-300 text-white disabled:opacity-50",
                        disabled: submitting.value || !eligibility.value?.integrationEnabled,
                        onClick: submitRegistration
                      }, _toDisplayString(_unref(t)("enbek.send")), 9, _hoisted_16)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(showForm))
            ? (_openBlock(), _createElementBlock("form", {
                key: 3,
                class: "rounded-lg border border-gray-200 bg-white p-5 space-y-5",
                onSubmit: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (save(false)), ["prevent"]))
              }, [
                _createElementVNode("h3", _hoisted_17, _toDisplayString(_unref(t)("enbek.newContract")), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.employee")), 1),
                    _createElementVNode("input", {
                      class: "input-form mt-1",
                      value: `${eligibility.value?.employeeName || ''} · ${
                eligibility.value?.employeeIin || ''
              }`,
                      disabled: ""
                    }, null, 8, _hoisted_19)
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.employer")), 1),
                    _createElementVNode("input", {
                      class: "input-form mt-1",
                      value: `${eligibility.value?.employerName || ''} · ${
                eligibility.value?.employerBin || ''
              }`,
                      disabled: ""
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.position")), 1),
                    _createElementVNode("input", {
                      class: "input-form mt-1",
                      value: eligibility.value?.positionName,
                      disabled: ""
                    }, null, 8, _hoisted_21)
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.contractNumber")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).contractNumber) = $event)),
                      required: "",
                      maxlength: "255"
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).contractNumber,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.contractDate")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      type: "date",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).contractDate) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _unref(form).contractDate]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.beginDate")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      type: "date",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).beginDate) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _unref(form).beginDate]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.endDate")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      type: "date",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).endDate) = $event))
                    }, null, 512), [
                      [_vModelText, _unref(form).endDate]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.contractTerm")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).contractTermCode) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).contractTermCode,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.establishedPost")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).establishedPost) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).establishedPost,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.establishedPostCode")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).establishedPostCode) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).establishedPostCode,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.partTime")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).partTimeCode) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).partTimeCode,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.remoteWork")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).remoteWorkCode) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).remoteWorkCode,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.workPlace")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).workPlace) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).workPlace,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.workPlaceKato")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).workPlaceKato) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).workPlaceKato,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.workPlaceCountry")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).workPlaceCountry) = $event)),
                      maxlength: "3"
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).workPlaceCountry,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.workingHours")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).workingHoursCode) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).workingHoursCode,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.tariffRate")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      type: "number",
                      min: "0.01",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).tariffRate) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).tariffRate,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("enbek.electronicContract")), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: "input-form mt-1",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).electronicContractCode) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _unref(form).electronicContractCode,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "px-4 py-2 border rounded-lg",
                    disabled: saving.value
                  }, _toDisplayString(_unref(t)("enbek.saveDraft")), 9, _hoisted_23),
                  _createElementVNode("button", {
                    type: "button",
                    class: "px-4 py-2 rounded-lg bg-primary-300 text-white disabled:opacity-50",
                    disabled: saving.value || !eligibility.value?.integrationEnabled,
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (save(true)))
                  }, _toDisplayString(_unref(t)("enbek.saveAndSend")), 9, _hoisted_24),
                  (registration.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "px-4 py-2",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (editing.value = false))
                      }, _toDisplayString(_unref(t)("common.cancel")), 1))
                    : _createCommentVNode("", true)
                ])
              ], 32))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})